import { isDefined } from '@sgme/fp';
import { type FormatNumberOptions, FormattedNumber } from 'react-intl';

interface FxFormattedNumberProps extends FormatNumberOptions {
  value: number | undefined;
  currency?: string;
  'data-e2e'?: string;
}

export function FxFormattedNumber({ value, currency, 'data-e2e': dataE2e, ...props }: FxFormattedNumberProps) {
  return (
    <span data-e2e={dataE2e}>
      {isDefined(value) && (
        <>
          <span className="monospace-numbers">
            <FormattedNumber value={value} maximumFractionDigits={0} minimumFractionDigits={0} {...props} />
          </span>
          {isDefined(currency) && <> {currency}</>}
        </>
      )}
    </span>
  );
}
